<!-- Titolo, contenuto e fascia delle azioni sono figli DIRETTI della superficie
     (niente <div> di raggruppamento): e' la condizione perche' la veste
     .izy-info-dialog-panel tenga la fascia panna a filo del bordo inferiore. -->
<h2 mat-dialog-title>Seleziona Codice ATECO</h2>

<mat-dialog-content>
  <mat-form-field appearance="outline" class="w-100 izy-ateco-search">
    <mat-label>Cerca codice ATECO</mat-label>
    <input
      matInput
      [(ngModel)]="searchTerm"
      (ngModelChange)="filterAtecoCodes()"
      placeholder="Cerca per nome o codice..." />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  @if (filteredAtecoCodes.length === 0) {
    <!-- Stesso riquadro panna delle voci, in tinta spenta: la ricerca a vuoto
         non e' un errore da segnalare in rosso, e' un elenco che per ora non
         ha righe. -->
    <div class="izy-ateco-empty izy-sharp-bl">
      <mat-icon>search_off</mat-icon>
      <span>Nessun codice ATECO trovato</span>
    </div>
  } @else {
    <!-- Ogni codice e' un riquadro a se', bordato nero 2px con l'angolo
         basso-sinistra vivo: la stessa grammatica dei riquadri di scelta
         dell'app. Quello selezionato si riempie di panna e alza il tratto a
         petrol, cosi' la scelta si legge dal blocco e non dal solo pallino. -->
    <mat-radio-group
      [(ngModel)]="selectedAtecoCodeId"
      class="izy-ateco-list">
      @for (code of filteredAtecoCodes; track code.id) {
        <div
          class="izy-ateco-option izy-sharp-bl"
          [class.izy-ateco-option--selected]="selectedAtecoCodeId === code.id">
          <mat-radio-button [value]="code.id" color="primary">
            <span class="izy-ateco-name">{{ code.name }}</span>
            <span class="izy-ateco-code">
              {{ code.ateco_division || '' }}.{{ code.ateco_class || ''
              }}.{{ code.ateco_subcategory || '' }}
            </span>
          </mat-radio-button>
        </div>
      }
    </mat-radio-group>
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="izy-dialog-actions">
  <button
    mat-stroked-button
    type="button"
    (click)="onCancel()"
    class="izy-button-ghost custom-button-border">
    <mat-icon>close</mat-icon>
    Annulla
  </button>

  <!-- L'azione della schermata: petrol pieno bordato nero, spenta finche' non
       c'e' un codice scelto. -->
  <button
    matButton="filled"
    type="button"
    [disabled]="!selectedAtecoCodeId"
    (click)="onConfirm()"
    class="ms-2 izy-button-primary custom-button-border">
    <mat-icon>check</mat-icon>
    Seleziona
  </button>
</mat-dialog-actions>
